/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Filters_Nearplatinum1Inputs */

const id_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mendekati Platinum`)
};

const ms_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hampir Platinum`)
};

const da_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tæt på Platinum`)
};

const de_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahe Platin`)
};

const en_us2_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Near Platinum`)
};

const es_es2_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de Platino`)
};

const es_mx2_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca de Platino`)
};

const fil_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Malapit sa Platinum`)
};

const fr_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proche du Platine`)
};

const it_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vicino al Platino`)
};

const hu_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platina közelében`)
};

const nl_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bijna platina`)
};

const no_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nær Platinum`)
};

const pl_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blisko Platyny`)
};

const pt_br2_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perto de Platina`)
};

const pt_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próximo da Platina`)
};

const ro_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproape de Platină`)
};

const fi_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähellä platinaa`)
};

const sv_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nära Platina`)
};

const vi_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gần Bạch kim`)
};

const tr_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Platine Yakın`)
};

const cs_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blízko platině`)
};

const bg_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Близо до Платина`)
};

const ru_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Близко к Платине`)
};

const uk_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майже платина`)
};

const ar_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قرب البلاتين`)
};

const hi_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्लैटिनम के करीब`)
};

const th_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ใกล้แพลตตินัม`)
};

const ja_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラチナ目前`)
};

const zh_cn2_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即将白金`)
};

const zh_hant1_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`即將白金`)
};

const ko_profile_library_filters_nearplatinum1 = /** @type {(inputs: Profile_Library_Filters_Nearplatinum1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`플래티넘 근접`)
};

/**
* | output |
* | --- |
* | "Near Platinum" |
*
* @param {Profile_Library_Filters_Nearplatinum1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_filters_nearplatinum1 = /** @type {((inputs?: Profile_Library_Filters_Nearplatinum1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Filters_Nearplatinum1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_filters_nearplatinum1(inputs)
	if (locale === "ms") return ms_profile_library_filters_nearplatinum1(inputs)
	if (locale === "da") return da_profile_library_filters_nearplatinum1(inputs)
	if (locale === "de") return de_profile_library_filters_nearplatinum1(inputs)
	if (locale === "en-US") return en_us2_profile_library_filters_nearplatinum1(inputs)
	if (locale === "es-ES") return es_es2_profile_library_filters_nearplatinum1(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_filters_nearplatinum1(inputs)
	if (locale === "fil") return fil_profile_library_filters_nearplatinum1(inputs)
	if (locale === "fr") return fr_profile_library_filters_nearplatinum1(inputs)
	if (locale === "it") return it_profile_library_filters_nearplatinum1(inputs)
	if (locale === "hu") return hu_profile_library_filters_nearplatinum1(inputs)
	if (locale === "nl") return nl_profile_library_filters_nearplatinum1(inputs)
	if (locale === "no") return no_profile_library_filters_nearplatinum1(inputs)
	if (locale === "pl") return pl_profile_library_filters_nearplatinum1(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_filters_nearplatinum1(inputs)
	if (locale === "pt") return pt_profile_library_filters_nearplatinum1(inputs)
	if (locale === "ro") return ro_profile_library_filters_nearplatinum1(inputs)
	if (locale === "fi") return fi_profile_library_filters_nearplatinum1(inputs)
	if (locale === "sv") return sv_profile_library_filters_nearplatinum1(inputs)
	if (locale === "vi") return vi_profile_library_filters_nearplatinum1(inputs)
	if (locale === "tr") return tr_profile_library_filters_nearplatinum1(inputs)
	if (locale === "cs") return cs_profile_library_filters_nearplatinum1(inputs)
	if (locale === "bg") return bg_profile_library_filters_nearplatinum1(inputs)
	if (locale === "ru") return ru_profile_library_filters_nearplatinum1(inputs)
	if (locale === "uk") return uk_profile_library_filters_nearplatinum1(inputs)
	if (locale === "ar") return ar_profile_library_filters_nearplatinum1(inputs)
	if (locale === "hi") return hi_profile_library_filters_nearplatinum1(inputs)
	if (locale === "th") return th_profile_library_filters_nearplatinum1(inputs)
	if (locale === "ja") return ja_profile_library_filters_nearplatinum1(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_filters_nearplatinum1(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_filters_nearplatinum1(inputs)
	return ko_profile_library_filters_nearplatinum1(inputs)
});
export { profile_library_filters_nearplatinum1 as "profile.library.filters.nearPlatinum" }